import Axios from 'axios/index'
import { Message } from 'element-ui'
import qs from 'qs'

const publicPostRequest = (url, postData, callback, catchFn) => {
  Axios.post(url, qs.stringify(postData)).then(response => {
    callback(response.data || {})
  }).catch(response => {
    catchFn(response)
  })
}

const publicRMPostRequest = (url, postData, callback, catchFn) => {
  Axios.post(url, qs.stringify(postData)).then(response => {
    callback(response)
  }).catch(response => {
    catchFn(response)
  })
}

const publicJSONPostRequest = (url, postData, callback, catchFn) => {
  Axios.post(url, JSON.stringify(postData), {
    headers: {
      'Content-Type': 'application/json'
    }
    // indices: false
  }).then(response => {
    callback(response || {})
  }).catch(response => {
    catchFn(response)
  })
}

const publicLoginPostRequest = (url, postData, header, callback, catchFn) => {
  Axios.post(url, qs.stringify(postData), {
    headers: header
    // indices: false
  }).then(response => {
    callback(response)
  }).catch(response => {
    catchFn(response)
  })
}

const publicFormPostRequest = (url, postData, callback, catchFn) => {
  Axios.post(url, postData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(response => {
    callback(response.data || {})
  }).catch(response => {
    catchFn(response)
  })
}

const publicGetRequest = (url, postData, callback, catchFn) => {
  Axios.get(url, {
    params: postData
  }).then(response => {
    callback(response.data || {})
  }).catch(response => {
    catchFn(response)
  })
}

const publicDeleteRequest = (url, postData, callback, message) => {
  Axios.delete(url, { params: postData }).then(response => {
    callback(response.data || {})
  }).catch(response => {
    Message({
      showClose: true,
      message: '删除失败',
      type: 'error'
    })
  })
}

const publicPutRequest = (url, postData, callback, catchFn) => {
  Axios.put(url, postData).then(response => {
    callback(response)
  }).catch(response => {
    catchFn(response)
  })
}

export default {
  publicPostRequest,
  publicRMPostRequest,
  publicGetRequest,
  publicJSONPostRequest,
  publicLoginPostRequest,
  publicFormPostRequest,
  publicDeleteRequest,
  publicPutRequest
}
